import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../utils/formatters';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const ListingCard = ({ property }) => {
  const coverImage = property.images[property.cover_index]?.src || 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80';
  const isSpecialStatus = property.status && property.status !== 'Disponible';
  const isResidential = ['Casa', 'Departamento'].includes(property.property_type);
  const isTerreno = property.property_type === 'Terreno';

  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 group relative"
    >
      <Link to={`/propiedad/${property.id}`} className="block relative aspect-[4/3] overflow-hidden">
        <img 
          src={coverImage} 
          alt={property.property_type} 
          className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${isSpecialStatus ? 'grayscale opacity-80' : ''}`} 
        />
        
        {isSpecialStatus && (
          <div className="absolute inset-0 flex items-center justify-center z-10">
            <div className="bg-gray-900/90 backdrop-blur-md text-white px-8 py-3 rounded-xl border-2 border-white/20 shadow-2xl rotate-[-5deg] transform scale-110">
              <p className="text-xl font-black uppercase tracking-[0.2em]">{property.status}</p>
            </div>
          </div>
        )}

        <div className="absolute top-4 left-4 flex gap-2">
          <span className="bg-emerald-600 text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-wider shadow-lg">
            {property.operation}
          </span>
          <span className="bg-white/90 backdrop-blur-sm text-gray-900 text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-wider shadow-sm border border-gray-200">
            {property.property_type}
          </span>
        </div>

        <div className="absolute bottom-4 left-4 right-4">
          <div className="bg-white/95 backdrop-blur-md p-3 rounded-xl shadow-lg border border-white/20">
            <p className="text-emerald-700 font-black text-lg">
              {formatCurrency(property.price, property.currency)}
              {property.operation === 'Renta' && <span className="text-xs font-normal"> /mes</span>}
            </p>
          </div>
        </div>
      </Link>

      <div className="p-5">
        <h3 className="text-gray-900 font-bold text-lg truncate mb-1">
          {property.property_type} en {property.city}
        </h3>
        <p className="text-gray-500 text-sm flex items-center gap-1 mb-4">
          <SafeIcon icon={FiIcons.FiMapPin} className="text-emerald-500" />
          {property.address}, {property.state}
        </p>
        
        <div className="flex items-center justify-between pt-4 border-t border-gray-50 text-gray-600">
          <div className="flex gap-4 text-xs font-bold">
            {isResidential && (
              <span className="flex items-center gap-1">
                <SafeIcon icon={FiIcons.FiInbox} /> {property.bedrooms || 0} hab
              </span>
            )}
            {!isTerreno && (
              <span className="flex items-center gap-1">
                <SafeIcon icon={FiIcons.FiDroplet} /> {property.bathrooms || 0} bañ
              </span>
            )}
            <span className="flex items-center gap-1">
              <SafeIcon icon={FiIcons.FiMaximize} /> {property.area || 0} {property.area_unit || (isTerreno ? 'v²' : 'm²')}
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ListingCard;